import { patchState, signalStoreFeature, withMethods } from '@ngrx/signals';
import { inject } from '@angular/core';
import { UserHttpService } from './user.httpservice';
import { rxMethod } from '@ngrx/signals/rxjs-interop';
import { UserInterface } from '../../app/shared/interfaces/global';
import {  userInitializeState } from './user.state';
import { concatMap, pipe, switchMap, tap } from 'rxjs';
import { MatSnackBar } from '@angular/material/snack-bar';
import { tapResponse } from '@ngrx/operators';
import { TranslateService } from '@ngx-translate/core';
import { HttpErrorResponse } from '@angular/common/http';

export function withUserMethods() {
  return signalStoreFeature(
    withMethods((store) => {
      const userHttpService = inject(UserHttpService);
      const $toast = inject(MatSnackBar);
      const $ts = inject(TranslateService);

      return {
        // асинхронные методы
        loadUser: rxMethod<void>(
          pipe(
            switchMap(() =>
              userHttpService
                .getProfile()
                .pipe(tap((res) => patchState(store, res))),
            ),
          ),
        ),
        updateUser: rxMethod<any>(
          pipe(
            switchMap((body) =>
              userHttpService.updateProfile(body).pipe(
                tapResponse({
                  next: (res) => {
                    patchState(store, res);
                    $toast.open($ts.instant('global.updated'), undefined, {
                      duration: 1500,
                      panelClass: ['success'],
                    });
                  },
                  error: () => {},
                }),
              ),
            ),
          ),
        ),
        uploadUserAvatar: rxMethod<FormData>(
          pipe(
            concatMap((file) =>
              userHttpService.loadAvatarToTemp(file).pipe(
                concatMap((tempRes) =>
                  userHttpService.uploadProfileAvatar(tempRes).pipe(
                    tapResponse({
                      next: (finalRes) => patchState(store, { avatar_url: finalRes }),
                      error: (error) => {
                        console.error('Upload failed:', error);
                      },
                    })
                  )
                ),
                tapResponse({
                  next: ()=> {},
                  error: (res: HttpErrorResponse) => {
                    if (res.status === 400) {
                      $toast.open(
                        $ts.instant('error.wrongFileExt'),
                        undefined,
                        {
                          duration: 2000,
                          panelClass: ['error'],
                        },
                      );
                    }
                  },
                }),
              )
            ),
          ),
        ),

        // синхронные методы
        setUser(user: UserInterface) {
          patchState(store, user);
        },
        clearUserStorage() {
          patchState(store, userInitializeState)
        }
      };
    }),
  );
}
